<div class="backpage-wrapper">
  <div class="support-content-creator">
    <div class="support-container padding s6 all">
      <div class="header">
        <h1>Support</h1>
      </div>
      <div class="support-form-container">
        <div class="welcome-text">
          <h2>
            Need Help? We're Here for You! Please take a moment to fill out this
            form with as much detail as possible. Once submitted, a support
            ticket will be automatically generated and sent to our dedicated
            support staff. We're committed to assisting you promptly and
            efficiently. Thank you for reaching out. Let's get your problem
            solved!
          </h2>
        </div>
        <div class="form-and-image-container">
          <div class="support-form-container">
            <form
              id="support-form"
              [formGroup]="supportForm"
              (ngSubmit)="submitForm()"
            >
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>User Email Address</mat-label>
                <input matInput formControlName="userEmail" readonly />
                <mat-error
                  *ngIf="
                    supportForm.controls['userEmail'].touched &&
                    supportForm.controls['userEmail'].hasError('required')
                  "
                >
                  Email is required.
                </mat-error>
                <mat-error
                  *ngIf="
                    supportForm.controls['userEmail'].touched &&
                    supportForm.controls['userEmail'].hasError('email')
                  "
                >
                  Please enter a valid email address.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>My question is related to:</mat-label>
                <mat-select formControlName="product">
                  <mat-option
                    *ngFor="let product of products"
                    [value]="product"
                    >{{ product }}</mat-option
                  >
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Subject</mat-label>
                <input matInput formControlName="subject" />
                <mat-error
                  *ngIf="
                    supportForm.controls['subject'].touched &&
                    supportForm.controls['subject'].hasError('required')
                  "
                >
                  Subject is required.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label
                  >Please provide details of your ALM problem.</mat-label
                >
                <textarea matInput formControlName="description"></textarea>
                <mat-error
                  *ngIf="
                    supportForm.controls['description'].touched &&
                    supportForm.controls['description'].hasError('required')
                  "
                >
                  Details are required.
                </mat-error>
              </mat-form-field>

              <h4>
                Screenshot Upload - This helps us tremendously with
                troubleshooting.
              </h4>

              <div class="file-upload-box" (click)="fileInput.click()">
                <input
                  #fileInput
                  type="file"
                  hidden
                  multiple
                  accept="
                    image/gif,
                    image/jpe,
                    image/jpg,
                    image/jpeg,
                    image/png,
                    image/svg+xml,
                    image/tiff,
                    image/tif
                     "
                  (change)="onFileSelected($event)"
                />
                <div>Upload files here</div>
                <mat-icon class="upload-icon">cloud_upload</mat-icon>

                <div *ngFor="let preview of filePreviews; let i = index">
                  <img
                    [src]="preview"
                    alt="preview"
                    style="
                      max-width: 100%;
                      max-height: 200px;
                      margin-bottom: 10px;
                    "
                  />
                  <mat-icon
                    class="remove-icon"
                    (click)="removeScreenshot(i)"
                    matTooltip="Remove"
                    >cancel</mat-icon
                  >
                </div>

                <div *ngFor="let name of fileNames">
                  <span>{{ name }}</span>
                </div>
              </div>

              <div class="button-container">
                <button
                  mat-raised-button
                  color="primary"
                  type="submit"
                  [disabled]="!supportForm.valid"
                  class="submit-button"
                  (submit)="submitForm()"
                >
                  Submit
                </button>
              </div>
            </form>
            <div *ngIf="submissionSuccess" class="success-message">
              Form Submitted Successfully!
            </div>
          </div>
          <div class="image-container">
            <img
              src="../../../assets/weDraw-Images/undraw_active_support_re_b7sj.svg"
              alt="man showing support"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
